// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SystemWide.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import RightPanelContent from './Izenda.RightPanelContent';
import Header from './Izenda.Header';

const SystemWide = connect()(props => {
  const { model, localization } = props;

  const header = {
    component: Header,
    headerName: localization.getText('COMMON_LABEL_SYSTEM_WIDE'),
    model
  };
  return (
    <Panel
      className='u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder'
      header={header}
      collapsible
      expanedOption={model.collapseAll}
    >
      <GridLayout>
        <GridLayout.Row className='u_noMarginAll u_borderTop'>
          <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
            <GridLayout.Col cols='3' className='grid-small-column u_borderRight u-bgWhite'>
              <div>
                <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                <span>
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_SYSTEM_WIDE_LABEL_CAN_SEE_SYSTEM_MESSAGES')}
                </span>
              </div>
            </GridLayout.Col>
            <RightPanelContent model={model} keysPath='systemwide.canSeeSystemMessages.value' />
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    </Panel>
  );
});

export default SystemWide;



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.SystemWide.js